import React from 'react';
import { Row } from 'saladsoft-primitive';
import styled, { css } from 'styled-components';

const PageLayout = ({
  selected,
  title,
  children,
  actionButton,
  onClick,
  useStickyHeader,
  style,
}: {
  selected?: boolean;
  title?: React.ReactNode;
  children?: React.ReactNode;
  actionButton?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  useStickyHeader?: boolean;
}) => {
  return (
    <Container selected={selected} onClick={onClick} style={style}>
      <Row
        justifyContent="space-between"
        padding={'20px 0px'}
        height={title ? '70px' : 'auto'}
        position={useStickyHeader ? 'sticky' : 'relative'}
        top={useStickyHeader ? '0' : 'auto'}
        zIndex={useStickyHeader ? '100' : 'auto'}
        backgroundColor={useStickyHeader ? '#fff' : 'transparent'}
      >
        <Title selected={selected}>{title}</Title>
        <>{actionButton}</>
      </Row>
      {children}
    </Container>
  );
};

const Container = styled.div<{ selected?: boolean }>`
  width: 100%;
  padding: 0px 20px;
  height: 100%;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  background-color: #fff;
  border-radius: var(--border-radius);
  color: #000;
  padding-bottom: 20px;
`;

const Title = styled.div<{ selected?: boolean }>`
  font-size: 24px;
  font-weight: 500;
  ${({ selected }) =>
    selected &&
    css`
      font-weight: 700;
    `}
`;

export default PageLayout;
